module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-modal"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.hideModal()
      }
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('questionModal.haveQuestion')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('questionModal.completeForm')))]), _vm._v(" "), _c('div', {
    staticClass: "inputs"
  }, [_c('div', {
    staticClass: "input",
    class: {
      error: _vm.nameError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "name",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('questionModal.name')
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "input",
    class: {
      error: _vm.emailError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "email",
    attrs: {
      "type": "email",
      "placeholder": _vm.$t('questionModal.email')
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('label', {
    staticClass: "select-box",
    class: {
      error: _vm.questionError
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.question),
      expression: "question"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.question = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('questionModal.queryTopicText')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "farms"
    }
  }, [_vm._v(_vm._s(_vm.$t('questionModal.queryTopic.questionOne')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "airport"
    }
  }, [_vm._v(_vm._s(_vm.$t('questionModal.queryTopic.questionTwo')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "area"
    }
  }, [_vm._v(_vm._s(_vm.$t('questionModal.queryTopic.questionThree')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('questionModal.queryTopic.questionFour')))]), _vm._v(" "), _c('option', [_vm._v(_vm._s(_vm.$t('questionModal.queryTopic.questionFive')))])])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    class: {
      error: _vm.contentError
    },
    attrs: {
      "placeholder": _vm.$t('questionModal.content')
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "rodo"
  }, [_vm._v(_vm._s(_vm.$t('questionModal.rodo'))), _c('router-link', {
    attrs: {
      "to": "/privacy-policy"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.hideModal($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('questionModal.rodoLink')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [(_vm.error) ? _c('div', {
    staticClass: "alert"
  }, [_vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('questionModal.errorMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.sendError) ? _c('div', {
    staticClass: "alert"
  }, [_vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('questionModal.errorSendMsg')))])]) : _vm._e(), _vm._v(" "), (_vm.sendComplete) ? _c('div', {
    staticClass: "alert done"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('questionModal.sendMsg')))])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "button btn orange",
    on: {
      "click": function($event) {
        _vm.sendForm()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('questionModal.send')) + " "), _c('span')])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hexagon-error"
  }, [_c('span', [_vm._v("!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hexagon-error"
  }, [_c('span', [_vm._v("!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hexagon-error"
  }, [_c('span', [_vm._v("!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hexagon-error"
  }, [_c('span', [_vm._v("!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67567d5b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 298
// module chunks = 0